import Vue from 'vue'
import App from './App'
import VueCookies from 'vue-cookies'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import request from './assets/utilits/request'
import enumList from './assets/utilits/enumList'
import common from './assets/utilits/common'
import regulars from './assets/utilits/regulars'
import ElementUI, { Drawer } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'

import 'font-awesome/css/font-awesome.min.css'
import './assets/css/reset.scss'
import * as echarts from 'echarts'
import Vue2Editor from 'vue2-editor'
import md5 from 'js-md5'
// import browserClient from '@apmplus/web'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 配置参数
// browserClient('init', {
//   aid: 407900
// })
// // 开启上报
// browserClient('start')

Vue.use(Vue2Editor)
Vue.prototype.$echarts = echarts
// require("./mock");
Vue.use(VueCookies)
Vue.use(ElementUI, { locale })
Vue.use(VueI18n)
Vue.prototype.$request = request
Vue.prototype.$enumList = enumList
Vue.prototype.$common = common
Vue.prototype.$regulars = regulars
Vue.prototype.$vueCookie = VueCookies
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
// Vue.prototype.$swiper = Swiper

const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
  messages: {
    'zh-CN': require('./assets/lang/zh'), // 中文语言包
    'en-US': require('./assets/lang/en') // 英文语言包
  }
})
router.beforeEach((to, from, next) => {
  const token = VueCookies.get('token')
  if (!token) {
    common.formatLoginUrl(to)
  } else {
    next()
  }
})
router.afterEach((to, from) => {
  store.dispatch('permissions/getAllrights').then(res => {
    const resData = res.data
    let arr = []
    if (resData.code == 0) {
      resData.companyrights[0].grouprights.map(item => {
        arr = arr.concat(item.rights)
      })
    }
    store.commit('permissions/updateAllRights', arr)
    if (to.meta.auth) {
      if (!common.isHaveAuthor(to.meta.auth[0], to.meta.auth[1])) {
        router.push({ path: '/resources/list', query: { mactype: 'ecs' } })
      }
    }
  })
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js